import { boot } from 'quasar/wrappers'
import qs from 'qs'

export default boot(({ app }) => {
	app.config.globalProperties.$qs = qs
})
